import { render } from "./GardenConfig.vue?vue&type=template&id=e4758846&scoped=true"
import script from "./GardenConfig.vue?vue&type=script&lang=js"
export * from "./GardenConfig.vue?vue&type=script&lang=js"

import "./GardenConfig.vue?vue&type=style&index=0&id=e4758846&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4758846"]])

export default __exports__